import { createStore } from "vuex";

const store = createStore({
  state: {
    transitioning: false,
    transitioningBack: false,
    path: "",
    previousRoute: null
  },
  mutations: {
    setTransitioning(state, payload) {
      state.transitioning = payload;
    },
    setTransitioningBack(state, payload) {
      state.transitioningBack = payload;
    },
    setPath(state, payload) {
      state.path = payload;
    },
    setPreviousRoute(state, payload) {
      state.previousRoute = payload;
    }
  }
});

export default store;
